import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReply = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M8.25 2.75 1.75 9l6.5 6.25v-4c3.333.583 10 2.75 10 6 0-9.75-6.667-10.323-10-10.5v-4Z"
	})]
});
const ForwardRef = forwardRef(SvgReply);
export { ForwardRef as ReactComponent };
